import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JwtDecoderService } from '../services/jwt-decoder.service';
import { AuthenticationRepository } from 'src/app/core/data/repository';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        const jwtDecoderService = this.injector.get(JwtDecoderService);
        const authRepository = this.injector.get(AuthenticationRepository)

        if (
          error instanceof HttpErrorResponse &&
          error.status === 401
        ) {
          jwtDecoderService.removeCurrentToken();
          authRepository.logout()
          this.router.navigate(['/login']);
          return throwError(error)
        }
         else {
          return throwError(error);
        }
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    // if (!this.isRefreshing) {
    //   this.isRefreshing = true;
    //   this.refreshTokenSubject.next(null);
    //   const authRepository = this.injector.get(AuthenticationRepository);
    //   return authRepository.refreshTheToken().pipe(
    //     switchMap((user: UserPayload) => {
    //       this.isRefreshing = false;
    //       this.refreshTokenSubject.next(user.payload.accessToken);
    //       console.log(this.refreshTokenSubject.value);
    //       return next.handle(this.addToken(request, user.payload.accessToken));
    //     })
    //   );
    // } else {
    //   return this.refreshTokenSubject.pipe(
    //     filter((token) => token != null),
    //     take(1),
    //     switchMap((jwt) => {
    //       return next.handle(this.addToken(request, jwt));
    //     })
    //   );
    // }
  }
}
